module.exports = __webpack_public_path__ + "static/media/2018_composite.a68306eb.jpg";